export default __webpack_public_path__ + "static/media/facebook_button.c5908aec.png";